import { client } from './index';

const self = {

    async sendReservations(ids: string){

        try{

            const response = await client.post('/monks/reservations', { ids });
            return response.data;
        
        }catch(err){

            return Promise.reject(err);

        }  

    },

    async getAllReservations(){
        
        try{

            const response = await client.get('/monks/reservations');
            return response.data.items;
        
        }catch(err){

            return Promise.reject(err);

        }

    }

}

export default self;
